import React from 'react';
import type { ClassifyPrediction } from '../types';

interface CardCandidateItemProps {
  prediction: ClassifyPrediction;
  onClick: (prediction: ClassifyPrediction) => void;
}

export default function CardCandidateItem({ prediction, onClick }: CardCandidateItemProps) {
  const card = prediction.card;
  const confidence = Math.round(prediction.confidence * 100);
  const imageUrl = card?.image_url_at_self_platform || card?.image_url;

  return (
    <button
      onClick={() => onClick(prediction)}
      className="w-full bg-white border border-border rounded-[16px] overflow-hidden hover:shadow-md hover:border-primary transition-all text-left"
    >
      {/* 卡片图片 */}
      <div className="aspect-[63/88] bg-background-secondary overflow-hidden relative p-1">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={card.name || '卡片'}
            className="w-full h-full object-cover"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-secondary-light">
            <svg className="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
          </div>
        )}
      </div>

      {/* 卡片信息 */}
      <div className="p-3">
        <h3 className="text-sm font-medium text-primary truncate">
          {card?.name || prediction.id_label}
        </h3>
        {card?.number && (
          <p className="text-xs text-secondary mt-1 truncate">
            编号: {card.number}
          </p>
        )}
        {card?.language && (
          <p className="text-xs text-secondary-light mt-0.5">
            语言: {card.language}
          </p>
        )}
        <div className="mt-2 flex items-center justify-between">
          <span className="text-xs text-secondary-light">
            匹配度: {confidence}%
          </span>
          <span className="text-xs text-primary font-medium">
            查看详情 →
          </span>
        </div>
      </div>
    </button>
  );
}
